module.exports = __webpack_public_path__ + "static/media/ke.87900162.svg";